import React, { useCallback, useEffect, useState, useRef, forwardRef } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
// import TooltipRight from "../../TooltipRight";
import Image from 'next/image';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
// import "./multiRangeSlider.css";

const MultiRangeSlider = forwardRef(
  (
    {
      min,
      max,
      onChange,
      initialMin,
      initialMax,
      editRange,
      setEditRange,
      step,
      title,
      belowRange,
      upperRange,
      guide = null,
      onChangeNewState,
      containerRange = '',
      wrapperContainer = '',
    },
    rangeRef,
  ) => {
    const [minVal, setMinVal] = useState(initialMin);
    const [maxVal, setMaxVal] = useState(initialMax);
    const { priceSymbol } = useLayoutContext();
    const tCommon = useTranslations('common');
    console.log('initial====', initialMin, initialMax, min, max);
    let minValRef = useRef(initialMin);
    let maxValRef = useRef(initialMax);
    console.log('vvvvvvvv====', minVal, maxVal, minValRef, maxValRef, minVal, maxVal, min, max);
    let range = useRef(null);
    useEffect(() => {
      minValRef.current = minVal;
    }, [minVal]);

    useEffect(() => {
      maxValRef.current = maxVal;
    }, [maxVal]);
    useEffect(() => {
      if (initialMin !== undefined) {
        setMinVal(initialMin);
      }
    }, [initialMin]);

    useEffect(() => {
      if (initialMax !== undefined) {
        setMaxVal(initialMax);
      }
    }, [initialMax]);
    // useEffect(() => {
    //   if (initialMin) {
    //     setMinVal(initialMin);
    //     // minValRef = useRef(initialMin);
    //   }
    // }, [initialMin]);

    // useEffect(() => {
    //   if (initialMax) {
    //     setMaxVal(initialMax);
    //     // maxValRef = useRef(initialMax);
    //   }
    // }, [initialMax]);

    useEffect(() => {
      if (editRange == true) {
        setMinVal(Number(initialMin));
        setMaxVal(Number(initialMax));
        minValRef.current = Number(initialMin);
        maxValRef.current = Number(initialMax);
        range = rangeRef;
        setEditRange(false);
      }
    }, [editRange, initialMax, initialMin, rangeRef]);
    console.log('input===', minVal, maxVal, minValRef, maxValRef);
    // Convert to percentage
    const getPercent = useCallback(
      (value) => Math.round(((value - min) / (max - min)) * 100),
      [min, max],
    );

    // Set width of the range to decrease from the left side
    useEffect(() => {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(maxValRef.current);

      if (range?.current) {
        range.current.style.left = `${minPercent}%`;
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }, [minVal, getPercent, range?.current]);

    // Set width of the range to decrease from the right side
    useEffect(() => {
      const minPercent = getPercent(minValRef.current);
      const maxPercent = getPercent(maxVal);

      if (range?.current) {
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }, [maxVal, getPercent, range?.current]);

    // Get min and max values when their state changes
    useEffect(() => {
      onChange({ min: minVal, max: maxVal });
    }, [minVal, maxVal]);

    const handleDragEnd = () => {
      const newState = { min: minValRef.current, max: maxValRef.current };
      onChangeNewState(newState); // Update state when dragging ends
    };

    return (
      <div
        className={`flex flex-col justify-center items-center w-full h-auto relative mx-auto ${styles.wrapperContainer} ${wrapperContainer}`}
      >
        <div className={`flex flex-row justify-between items-center ${styles.container} h-auto`}>
          <div
            className={`flex flex-row justify-start items-center w-auto h-auto ${styles.titleContainer}`}
          >
            {/* <p className={`${styles.title} `}>{`${initialMin}-${initialMax}`}</p> */}
            {/* {guide && (
              <TooltipRight
                text={guide}
                cursor={true}
                extraClassName={`flex flex-row justify-center items-center w-auto h-auto`}
                // extraClassName={toolTipClassname}
              >
                <Image src="/imgs/dashboard/help.svg" width={24} height={24} />
              </TooltipRight>
            )} */}
          </div>
          <p className={`${styles.title} `}>
            {title}
            <span className={styles.cpuUnit}></span>{' '}
          </p>
        </div>
        <div className={`${'containerRange'} ${containerRange}`}>
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={minVal}
            onChange={(event) => {
              const value = Math.min(Number(event.target.value), maxVal - step);
              setMinVal(value);
              minValRef.current = value;
            }}
            className="thumb thumb--left"
            style={{ zIndex: minVal > max - 100 && '5' }}
            onMouseUp={handleDragEnd} // Trigger when user releases mouse
            onTouchEnd={handleDragEnd} // Trigger when user releases touch
          />
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={maxVal}
            onChange={(event) => {
              const value = Math.max(Number(event.target.value), minVal + step);
              setMaxVal(value);
              maxValRef.current = value;
            }}
            className="thumb thumb--right"
            onMouseUp={handleDragEnd} // Trigger when user releases mouse
            onTouchEnd={handleDragEnd} // Trigger when user releases touch
          />

          <div className="slider">
            <div className="slider__track" />
            <div ref={range} className="slider__range" />
            {/* <div className="slider__left-value">{minVal}</div>
            <div className="slider__right-value">{maxVal}</div> */}
          </div>
        </div>
        <div className={`${styles.rangeContainer}`}>
          <p className={`${styles.title} `}>
            {`${parseFloat(maxVal).toLocaleString()} ${priceSymbol}`}
          </p>
          <p className={`${styles.title} `}>
            {`${parseFloat(minVal).toLocaleString()} ${priceSymbol} `}
          </p>
        </div>
      </div>
    );
  },
);

MultiRangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};
MultiRangeSlider.displayName = 'MultiRangeSlider';
export default MultiRangeSlider;

// import React, { useCallback, useEffect, useState, useRef, forwardRef } from "react";
// import PropTypes from "prop-types";
// // import "./multiRangeSlider.css";

// const MultiRangeSlider = forwardRef(({ min, max, onChange, initialMax, initialMin },range) => {
//   const [minVal, setMinVal] = useState(min);
//   const [maxVal, setMaxVal] = useState(max);
//   const minValRef = useRef();
//   const maxValRef = useRef();
//   // const range = useRef(null);

//   // useEffect(()=>{
//   //   setMinVal(initialMin)
//   //   setMaxVal(initialMax)
//   // },[initialMin, initialMax])
//   // Convert to percentage
//   const getPercent = useCallback(
//     (value) => Math.round(((value - min) / (max - min)) * 100),
//     [min, max]
//   );

//   // Set width of the range to decrease from the left side
//   useEffect(() => {
//     const minPercent = getPercent(minVal);
//     const maxPercent = getPercent(maxValRef.current);

//     if (range?.current) {
//       range.current.style.left = `${minPercent}%`;
//       range.current.style.width = `${maxPercent - minPercent}%`;
//     }
//   }, [minVal, getPercent, range]);

//   // Set width of the range to decrease from the right side
//   useEffect(() => {
//     const minPercent = getPercent(minValRef.current);
//     const maxPercent = getPercent(maxVal);

//     if (range?.current) {
//       range.current.style.width = `${maxPercent - minPercent}%`;
//     }
//   }, [maxVal, getPercent,range]);

//   // Get min and max values when their state changes
//   useEffect(() => {
//     onChange({ min: minVal, max: maxVal });
//   }, [minVal, maxVal, onChange]);

//   return (
//     <div className="container">
//       <input
//         type="range"
//         min={min}
//         max={max}
//         value={minVal}
//         onChange={(event) => {
//           const value = Math.min(Number(event.target.value), maxVal - 1);
//           setMinVal(value);
//           minValRef.current = value;
//         }}
//         className="thumb thumb--left"
//         style={{ zIndex: minVal > max - 100 && "5" }}
//       />
//       <input
//         type="range"
//         min={min}
//         max={max}
//         value={maxVal}
//         onChange={(event) => {
//           const value = Math.max(Number(event.target.value), minVal + 1);
//           setMaxVal(value);
//           maxValRef.current = value;
//         }}
//         className="thumb thumb--right"
//       />

//       <div className="slider">
//         <div className="slider__track" />
//         <div ref={range} className="slider__range" />
//         <div className="slider__left-value">{minVal}</div>
//         <div className="slider__right-value">{maxVal}</div>
//       </div>
//     </div>
//   );
// });

// MultiRangeSlider.propTypes = {
//   min: PropTypes.number.isRequired,
//   max: PropTypes.number.isRequired,
//   onChange: PropTypes.func.isRequired
// };

// export default MultiRangeSlider;
